import styled from '@emotion/styled';
import { ReactComponent as AlreadyCompleted } from 'images/already-completed.svg';

export const AlreadyCompletedSvg = styled(AlreadyCompleted)`
    width: 100%;
    margin-top: 13vh;
    margin-bottom: 27px;
`;
